<template>
    <div class="table-striped">
        <div class="table-box" v-if="!empty && loadStatusTbl">
            <md-table md-card v-model="items" :table-header-color="tableHeaderColor">
                <md-table-row slot="md-table-row" slot-scope="{ item }" md-dense>
                    <md-table-cell md-label="Логин">{{ item.name }}</md-table-cell>
                    <md-table-cell md-label="E-mail">{{ item.email }}</md-table-cell>
                    <md-table-cell md-label=ФИО>{{ item.last_name }} {{ item.first_name }} {{ item.middle_name }}</md-table-cell>
                    <md-table-cell md-label=Роль>{{ getRole(item.role_id) }}</md-table-cell>
                    <md-table-cell md-label="Статус">{{ item.status.name }}</md-table-cell>
                    <md-table-cell>
                        <md-avatar>
                            <md-tooltip>Редактировать</md-tooltip>
                            <md-icon @click.native="editUser(item.id, item.company_id)" class="md-icon-font-green md-theme-default pointer">edit</md-icon>
                        </md-avatar>
                    </md-table-cell>
                </md-table-row>
            </md-table>
            <div class="pagination-block">
            </div>
        </div>

        <div class="loading-overlay" v-if="!loadStatusTbl">
            <md-progress-spinner :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
        </div>
        <div class="md-empty-state" v-if="empty">
            <h1>Записей не найдено</h1>
        </div>
    </div>
</template>
<script>
import HttpClient from '@/api/calls'
// import user from '../../store/modules/user'

export default {
  name: 'UsersTable',
  props: {
    tableHeaderColor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selected: [],
      items: [],
      roles: [],
      empty: true,
      loadStatusTbl: false,
      shopId: false,
      companyId: false,
      currentSort: 'name',
      currentSortOrder: 'asc',
      currentSortOld: 'name',
      currentSortOrderOld: 'asc'
    }
  },
  methods: {
    getRole (role) {
      return this.roles[role]
    },
    getUsersByShop () {
      this.shopId = this.$route.params.id

      if (this.$store.state.filtersUsers.q !== null) {
        return HttpClient.httpGet('users.search', this.prepareUsersFilters())
      }

      if (this.shopId) {
        return HttpClient.httpGet(['users.listByShop', this.shopId], this.prepareUsersFilters())
      }
      return HttpClient.httpGet('users.search', this.prepareUsersFilters())
    },
    parseResponse (userData) {
      if (userData.meta) {
        this.meta = userData.meta
      }
      if (userData.data && userData.data.length !== 0) {
        this.items = userData.data
        this.empty = false
      } else {
        this.items = []
        this.empty = true
      }
      this.loadStatusTbl = true
    },
    refreshData () {
      const $this = this
      this.getListShop().then(function (response) {
        $this.parseResponse(response)
      })
    },
    prepareUsersFilters () {
      let params = {}
      params['filter'] = this.$store.state.filtersUsers
      return params
    },
    editUser (id, shopId) {
      this.$store.state.editId = id
      this.$store.state.shopId = shopId
      this.$emit('editUser')
    }
  },
  async created () {
    this.roles = this.$store.state.roles
    const $this = this
    let data = await Promise.resolve($this.getUsersByShop())
    if (data) {
      this.parseResponse(data)
    } else {
      this.loadStatusTbl = true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/users/UsersTable.vue